import React from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';
import { setNavbarTab } from '../../Actions/ToggleActions';
import { TAB_TYPES } from '../../Constants';
import TabContactComponent from '../Tabs/TabContactComponent';
import TabFilterComponent from '../Tabs/TabFilterComponent';
import TabCareer from '../Tabs/TabCareer';
import TabFavouritesComponent from '../Tabs/TabFavouritesComponent';
import { getLocalAreaData } from '../../Utils/localStorageUtil';

const NavbarTab = (props) => {
  const dispatch = useDispatch();
  const { navbar: { activeTab, isLoading } } = useSelector(state => state.ToggleReducer);

  const closeTabView = () => {
    dispatch(setNavbarTab(''));
  };

  const renderOpenTab = () => {
    const wrapperClasses = classNames('tab-wrapper', { hidden: !activeTab, loading: isLoading });
    let tabToRender = null;
    let hideTabClose = null;

    switch (activeTab) {
      case TAB_TYPES.TEACHER:
        tabToRender = <TabCareer closeTabView={() => closeTabView()} />;
        break;
      case TAB_TYPES.CONTACT:
        tabToRender = <TabContactComponent closeTabView={() => closeTabView()} />;
        break;
      case TAB_TYPES.FILTER:
        tabToRender = <TabFilterComponent mapCenter={props.mapCenter} />;
        break;
      case TAB_TYPES.FAVORITES:
        tabToRender = <TabFavouritesComponent />;
        hideTabClose = getLocalAreaData().length === 0;
        break;
      default:
        tabToRender = null;
    }

    return (
      activeTab ?
        <div className={wrapperClasses} id="tab-modal-parent">
          <div className="loading-indicator">
            <div className="sk-folding-cube">
              <div className="sk-cube1 sk-cube" />
              <div className="sk-cube2 sk-cube" />
              <div className="sk-cube4 sk-cube" />
              <div className="sk-cube3 sk-cube" />
            </div>
          </div>
          <div id="tab-content-div" className="tab-content">
            {!hideTabClose &&
              <input
                aria-label="close"
                className="btn close"
                type="button"
                onClick={() => closeTabView()}
              />

            }
            {tabToRender}
          </div>
        </div>
        : null
    );
  };

  return (
    <ReactCSSTransitionGroup
      transitionName="nav-bar"
      transitionEnterTimeout={500}
      transitionLeaveTimeout={300}
    >
      {renderOpenTab()}
    </ReactCSSTransitionGroup>

  );
};

export default NavbarTab;



// WEBPACK FOOTER //
// ./src/Components/Navbar/NavbarTab.js